var _defs, _path, _path2, _path3, _g, _g2, _g3, _g4, _path4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationSleep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 183.352,
    height: 112,
    viewBox: "0 0 183.352 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(0,63,162,0.05);}.b{fill:#0081c6;}.c{fill:#001c85;}.d{fill:#fff;}.e,.g,.i,.j,.k{fill:none;}.e,.g{stroke:#fff;}.e,.g,.h,.i,.j{stroke-linecap:square;}.e,.g,.h,.j,.k{stroke-miterlimit:10;}.e{stroke-width:2px;}.f{fill:#003fa2;}.h{fill:#ccd1e7;}.h,.i,.j,.k{stroke:#003fa2;stroke-width:4px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M96.223,64.86H214.862l-64.712,112H31.51Z",
    transform: "translate(-31.51 -64.86)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M36.89,64.86H47.65l-5.38,9.311H31.51Z",
    transform: "translate(-29.589 26.915)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M34.018,64.86h5.016L36.526,69.2H31.51Z",
    transform: "translate(-22.527 9.885)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(118.022 79.086)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M45.377,64.86H73.111l-13.867,24H31.51Z",
    transform: "translate(-31.51 -64.86)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.479 5.914)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M6.961,7.633,7.359,0h-2.7l.4,7.633Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(4.5 9)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-694 11.999)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M41.185,64.86H60.534L50.859,81.6H31.51Z",
    transform: "translate(785.512 -71.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M40,2h5.669v.945L40,7.669v.945h5.669",
    transform: "translate(788.699 -3.291)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-696.814 12.173)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M39.092,64.86H54.255L46.673,77.982H31.51Z",
    transform: "translate(808.312 -60.033)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M40,2h4.344v.724L40,6.344v.724h4.344",
    transform: "translate(809.023 6.854)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-693.814 12.072)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M35.634,64.86h8.249L39.759,72H31.51Z",
    transform: "translate(815.685 -73.289)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M40,2h2.613v.436L40,4.613v.436h2.613",
    transform: "translate(812.073 -8.385)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M34.848,64.86h6.676l-3.338,5.777H31.51Z",
    transform: "translate(-13.448 17.449)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.782 -2.017)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 6.667,
    cy: 6.667,
    r: 6.667,
    transform: "translate(44.227 71.356)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M13.35,24a7.736,7.736,0,0,0,14,0",
    transform: "translate(13.875 27.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M28.35,24a7.736,7.736,0,0,0,14,0",
    transform: "translate(32.212 27.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M90.9,35.66a8.75,8.75,0,0,0-2.211.311,39.96,39.96,0,0,0-75.574,0,8.75,8.75,0,0,0-2.222-.311,8.89,8.89,0,1,0,0,17.78c.089,0,.169-.022.256-.027a39.993,39.993,0,0,0,79.5,0c.087,0,.167.027.256.027a8.89,8.89,0,0,0,0-17.78Z",
    transform: "translate(0 9.027)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M28.891,9a8.89,8.89,0,1,0,6.285,15.175",
    transform: "translate(22.002 9.017)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationSleep);
export default __webpack_public_path__ + "static/media/Illustration_Sleep.93262313c902a412ddbaef2e54f604dc.svg";
export { ForwardRef as ReactComponent };